<template>
  <div class="support-chat-messages__list">
    <!-- <CButton 
      class="support-chat-messages__list__delete-icon" 
      color="danger" 
      circle
      @click="deleteCurrentChannel"  
    >
      <CIcon
        :content="$options.iconX"
      />
    </CButton> -->
    <slot name="header"></slot>

    <div
      class="support-chat-messages__list-message"
      :class="{ 'sender-message': isManager(message) }"
      v-for="(message, index) in messages"
      :key="`message-${message.id}`"
    >
      <div
        v-if="!isManager(message)"
        class="support-chat-messages__list-message-icon"
      >
        <VUserIcon :src="message.icon" />
      </div>
      <div class="support-chat-messages__list-message-text"
      :class="[
          'support-chat-messages__list-message-text',
          (index > selectedChannel && selectedChannel.lastReadMessageIndex ||
          selectedChannel && selectedChannel.lastReadMessageIndex === null) && !isManager(message)
            ? 'unread-message'
            : ''
        ]"
      >
      <div>{{ message.body }}
        <p class="mb-0 text-muted text-sm font-weight-normal h6">{{ dateConverted(message.date) }}</p></div>
        <div class="upport-chat-message-delete" @click="deleteMessage(message)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="Delete"><path d="M24.2,12.193,23.8,24.3a3.988,3.988,0,0,1-4,3.857H12.2a3.988,3.988,0,0,1-4-3.853L7.8,12.193a1,1,0,0,1,2-.066l.4,12.11a2,2,0,0,0,2,1.923h7.6a2,2,0,0,0,2-1.927l.4-12.106a1,1,0,0,1,2,.066Zm1.323-4.029a1,1,0,0,1-1,1H7.478a1,1,0,0,1,0-2h3.1a1.276,1.276,0,0,0,1.273-1.148,2.991,2.991,0,0,1,2.984-2.694h2.33a2.991,2.991,0,0,1,2.984,2.694,1.276,1.276,0,0,0,1.273,1.148h3.1A1,1,0,0,1,25.522,8.164Zm-11.936-1h4.828a3.3,3.3,0,0,1-.255-.944,1,1,0,0,0-.994-.9h-2.33a1,1,0,0,0-.994.9A3.3,3.3,0,0,1,13.586,7.164Zm1.007,15.151V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Zm4.814,0V13.8a1,1,0,0,0-2,0v8.519a1,1,0,0,0,2,0Z" fill="#d85b53" class="color000000 svgShape"></path></svg>
        </div>
      </div>
    </div>
    <div class="support-chat-messages__list-input">
      <form @submit.prevent>
        <input
          placeholder="Start typing here"
          @keypress="startTyping"
          @keyup.enter="sendMessage"
          ref="messageInput"
          @focus="inputFocus"
        />
        <button @click="sendMessage">Send</button>
      </form>
    </div>

    <CElementCover v-if="loading" :opacity="0.8" />
  </div>
</template>
<script>
import { createSupportStoreMixin, supportStore } from "@/mixins/supportMixin";
import { cilTrash } from "@coreui/icons";
import ModalType from "@/utils/dictionaries/modalType";
import moment from "moment"
export default {
  iconX: cilTrash,

  name: "TheChatMessagesList",

  mixins: [createSupportStoreMixin()],

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {

    messages() {
      return this[supportStore.getterTypes.GETTER_MESSAGES];
    },
    selectedChannel() {
      return this[supportStore.getterTypes.GETTER_SELECTED_CHANNEL];
    }
  },

  watch: {
    messages() {
      this.$nextTick(() => {
        if (this.$el && this.$el.parentNode) {
          this.$el.parentNode.scrollTop = this.$el.parentNode.scrollHeight;
        }
      });
    }
  },

  methods: {
    dateConverted(date){
      return moment(date).format('lll')
    },
    deleteMessage(message){
     this[supportStore.actionTypes.ACTION_DELETE_MESSAGE]({message});

      // const deleting = async () => {
      //   const res = await this[supportStore.actionTypes.ACTION_DELETE_MESSAGE]({message});
      //   console.log("res",res)
      //   this.$modals.close();
      // };

      // this.$modals.open(ModalType.ConfirmationModal, {
      //   title: "Deletion",
      //   body: "Are you sure you want to delete the message?",
      //   buttonText: "Delete",
      //   onClickButton: deleting
      // });
    },
    isManager(message) {
      return message.isManager;
    },

    startTyping() {},

    deleteCurrentChannel() {
      const deleting = async () => {
        this[supportStore.actionTypes.ACTION_DELETE_CHANNEL]();
        this.$modals.close();
      };

      this.$modals.open(ModalType.ConfirmationModal, {
        title: "Deletion",
        body: "Are you sure you want to delete the current chat?",
        buttonText: "Delete",
        onClickButton: deleting
      });
    },

    sendMessage() {
      const m = this.$refs.messageInput.value;

      if (this.$refs.messageInput.value.trim().length > 0) {
        this.$refs.messageInput.value = "";
        this[supportStore.actionTypes.ACTION_SEND_MESSAGE]({
          message: m,
          username: this.selectedChannel.username
        });
      }
    },
    readMessages(){
      this[supportStore.actionTypes.ACTION_READ_MESSAGE]({
       conversation: this.selectedChannel, 
       messageIndex: this.messages.length + 1
      });
    },
    inputFocus(){
      this[supportStore.actionTypes.ACTION_READ_MESSAGE]({
       conversation: this.selectedChannel, 
       messageIndex: this.messages.length
      });
    }
  }
};
</script>
